//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            items: [
                {
                    img: '/images/landingpage/icon_self.svg',
                    text: this.$lang.get('landingpage.quotes.self')
                },
                {
                    img: '/images/landingpage/icon_progress.svg',
                    text: this.$lang.get('landingpage.quotes.progress')
                },
                {
                    img: '/images/landingpage/icon_plan.svg',
                    text: this.$lang.get('landingpage.quotes.plan')
                },
                {
                    img: '/images/landingpage/icon_quality.svg',
                    text: this.$lang.get('landingpage.quotes.quality')
                }
            ]
        };
    }
};
